module.exports = __webpack_public_path__ + "img/zxx.003ee95a.png";